/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import type { BaseEvent } from "../../types"
import type {
  AdvisorInfo,
  SessionContext,
  UsageAnalyticsEventTransformer,
} from "../types"

/**
This module only emits a Session Activity event for signalling external scripts that there was integration, without providing what kind of interaction happened.
This is mainly used to keep tracking sessions for use in Purchase Events.
*/

type SessionActivityEvent = BaseEvent & {
  type: "session-activity"
  data: {
    sessionId: string
  }
}

export const SessionActivityEvents: UsageAnalyticsEventTransformer & {
  startOver: (
    advisor: AdvisorInfo,
    context: SessionContext
  ) => SessionActivityEvent[]
} = {
  questionAnswered: (
    advisor: AdvisorInfo,
    context: SessionContext
  ): SessionActivityEvent[] => sessionActivityEvent(advisor, context),

  adviceGiven: (
    advisor: AdvisorInfo,
    context: SessionContext
  ): SessionActivityEvent[] => sessionActivityEvent(advisor, context),

  startOver: (
    advisor: AdvisorInfo,
    context: SessionContext
  ): SessionActivityEvent[] => sessionActivityEvent(advisor, context),

  clickedOnProduct: (
    advisor,
    context: SessionContext
  ): SessionActivityEvent[] => sessionActivityEvent(advisor, context),

  customerInfoSubmitted: (
    advisor,
    context: SessionContext
  ): SessionActivityEvent[] => sessionActivityEvent(advisor, context),

  infoPageCustomerInfoSubmitted: (
    advisor,
    context: SessionContext
  ): SessionActivityEvent[] => sessionActivityEvent(advisor, context),

  noResultsCustomerInfoSubmitted: (
    advisor,
    context: SessionContext
  ): SessionActivityEvent[] => sessionActivityEvent(advisor, context),

  conversationStarted: (
    advisor,
    context: SessionContext
  ): SessionActivityEvent[] => sessionActivityEvent(advisor, context),
}

function sessionActivityEvent(
  advisor: AdvisorInfo,
  context: SessionContext
): SessionActivityEvent[] {
  return [
    {
      advisorId: advisor.id,
      advisorName: advisor.name,
      type: "session-activity",
      data: {
        sessionId: context.sessionId,
      },
    },
  ]
}
